

(function(window, jQuery) {
  var $window = jQuery(window);

  var BackButton = function(element) {
    this.element = element;
  };
  BackButton.prototype.initialise = function() {
    this.element.on('click', this.onClick);
  };
  BackButton.prototype.onClick = function(event) {
    event.preventDefault();

    window.history.back();
  };


  $window.on('load', function() {
    var buttons = jQuery('[data-sbm-back-button]');

    if (buttons.length) {
      for (var i = 0; i < buttons.length; i++) {
        var item = jQuery(buttons[i]);

        var block = new BackButton(item);
        block.initialise();
      }
    }
  });
})(window, jQuery);

